import React, { useState } from 'react';

import { useConfiguration } from '../../../hooks/Configuration';
import Chat from '../Chat';

interface IWindowProps {
    open: boolean
}

function Window({ open }: IWindowProps) {
    const configuration = useConfiguration();
    const [opened, setOpened] = useState<boolean>(false);

    if (!opened) {
        if (open) setOpened(true);
        else return (null);
    }

    return (
        <div
            id='stx-chat-window'
            style={{
                display: open ? 'flex' : 'none',
                backgroundColor: configuration?.styles.windowBgColor
            }}>
            <h1 style={{
                backgroundColor: configuration?.styles.nameBgColor,
                color: configuration?.styles.nameColor
            }}>
                {
                    configuration?.styles.logoImage &&
                    <div
                        id='stx-chat-logo'
                        style={{
                            backgroundImage: `url(${configuration?.mediaPath}${configuration?.styles.logoImage})`
                        }} />
                }
                {configuration?.texts.name}
            </h1>

            <Chat />
        </div>
    );
}

export default Window;
